import React, { useEffect } from 'react'
import { Box, CardMedia, CircularProgress, Typography } from '@mui/material'
import { BrokenImageOutlined } from '@mui/icons-material'

import { useCoverStore } from 'store/CoverStore'

import "./Document.scss"

export default function DocumentCover({ cover_id }) {
    const { covers, fetchCover } = useCoverStore();

    useEffect(() => {
        fetchCover(cover_id);
    }, [cover_id, fetchCover]);

    if (covers[cover_id]?.loading) {
        return <CircularProgress className="loading-cover" />
    }

    if (covers[cover_id]) {
        return (
            <CardMedia
                className="cover"
                image={covers[cover_id]?.data}
                title="Okładka"
                component="img"
            />
        )
    }

    return (
        <Box className="no-cover-placeholder">
            <BrokenImageOutlined fontSize="large" />
            <Typography variant="body2" color="text.secondary">
                Brak okładki
            </Typography>
        </Box>
    )
}
